import { render, staticRenderFns } from "./WorkspaceSelector.vue?vue&type=template&id=ecd7cd04&scoped=true"
import script from "./WorkspaceSelector.vue?vue&type=script&lang=js"
export * from "./WorkspaceSelector.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSelector.vue?vue&type=style&index=0&id=ecd7cd04&prod&scoped=true&lang=css"
import style1 from "./WorkspaceSelector.vue?vue&type=style&index=1&id=ecd7cd04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd7cd04",
  null
  
)

export default component.exports